import React from "react";
import styles from "./ApplicantDetails.module.scss";
import { Icon } from "../../atoms/Icon";
import { Collapse } from "../../atoms/Collapse";
import { Label, Tooltip, Position } from "@blueprintjs/core";
import { formatDate } from "./helper";
import classnames from "classnames";

export function ApplicantDetails({
  firstApplicationEvent,
  applicant,
  getSocialUrlByName,
  isSocialConnected,
  socialIdentites
}) {
  return (
    <>
      <div className={styles.simpleView}>
        <label className={styles.sectionTitle}>Application Date</label>
        <div>{formatDate(firstApplicationEvent.createdAt)}</div>
      </div>

      <Collapse
        text={firstApplicationEvent.message || "N/A"}
        title="Application Message"
      />

      <Collapse
        text={applicant.bio || "N/A"}
        title={`${applicant.name}’s Bio`}
      />
      {socialIdentites.length !== 0 && (
        <div className={styles.socialNetwork}>
          <label>{applicant.name}’s Social Networks</label>
          <div>
            {isSocialConnected("instagram") && (
              <div
                className={styles.socialMediaListItem}
                onClick={() => {
                  window.open(getSocialUrlByName("instagram"), "_blank");
                }}
              >
                <Icon
                  name="Instagram"
                  size={27}
                  className={styles.socialMediaIcon}
                />
                <span className={styles.socialMediaText}>Instagram</span>
              </div>
            )}
            {isSocialConnected("facebook") && (
              <div
                className={styles.socialMediaListItem}
                onClick={() => {
                  window.open(getSocialUrlByName("facebook"), "_blank");
                }}
              >
                <Icon
                  name="Facebook"
                  size={27}
                  className={styles.socialMediaIcon}
                />
                <span className={styles.socialMediaText}>Facebook</span>
              </div>
            )}
            {isSocialConnected("twitter") && (
              <div
                className={styles.socialMediaListItem}
                onClick={() => {
                  window.open(getSocialUrlByName("twitter"), "_blank");
                }}
              >
                <Icon
                  name="Twitter"
                  size={27}
                  className={styles.socialMediaIcon}
                />
                <span className={styles.socialMediaText}>Twitter</span>
              </div>
            )}
            {isSocialConnected("youtube") && (
              <div
                className={styles.socialMediaListItem}
                onClick={() => {
                  window.open(getSocialUrlByName("youtube"), "_blank");
                }}
              >
                <Icon
                  name="Youtube"
                  size={27}
                  className={styles.socialMediaIcon}
                />
                <span className={styles.socialMediaText}>YouTube</span>
              </div>
            )}
          </div>
        </div>
      )}
      {applicant.videos && applicant.videos.length !== 0 && (
        <div className={styles.videoHistoryContainer}>
          <div className={styles.videoHistory}>
            <label>{applicant.name}’s Past Videos</label>
            <div className={styles.videoContainer}>
              {applicant.videos
                .slice(0, Math.ceil(applicant.videos.length / 2))
                .map((video) => (
                  <VideoItem video={video} key={video.id} />
                ))}
            </div>
            <div className={styles.videoContainer}>
              {applicant.videos
                .slice(
                  Math.ceil(applicant.videos.length / 2),
                  applicant.videos.length
                )
                .map((video) => (
                  <VideoItem video={video} key={video.id} />
                ))}
            </div>
          </div>
        </div>
      )}
      <div className={styles.activityTimeline}>
        <label>{applicant.name}’s Activity Timeline</label>
        <ul className={styles.timeline}>
          {applicant.applicationEvents.map((event) => (
            <TimeLineEvent event={event} key={event.id} />
          ))}
        </ul>
      </div>

      {applicant.partneredBrands && applicant.partneredBrands.length !== 0 && (
        <div className={styles.partnerBrand}>
          <label>{applicant.name}’s Partnered Brands</label>
          <div className={styles.brandsLogo}>
            {applicant.partneredBrands.map((brand) => (
              <div className={styles.logoContainer} key={brand.id}>
                <img src={brand.picture} alt={brand.name} />
                <p>{brand.name}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}

function TimeLineEvent({ event }) {
  const status = event.status.toUpperCase();
  const eventClassName = classnames(
    status == "APPLIED" && styles.applied,
    status == "DECLINED" && styles.declined,
    status == "APPROVED" && styles.approved
  );
  return (
    <li>
      <label>{formatDate(event.createdAt)}</label>
      <span className={eventClassName}>{event.status.toUpperCase()}</span>
      <Collapse text={event.message || "N/A"} />
    </li>
  );
}

function VideoItem({ video }) {
  return (
    <div className={styles.videoItem}>
      <div
        className={styles.videoIcon}
        style={{ backgroundImage: `url('${video.thumbnailUrl}')` }}
        onClick={() =>
          window.open(`${process.env.REACT_APP_WEB_URL}/watch/${video.id}`)
        }
      >
        <Icon
          name="play"
          size={30}
          className={styles.playIcon}
          onClick={() => {}}
        />
      </div>
      <div className={styles.videoDetail}>
        <Label>{video.name}</Label>
        <span>{video.owner.name}</span>
        <div className={styles.videoMetaData}>
          <div>
            <label>Sales Made</label>
            <span>{video.stats.totalSales}</span>
          </div>
          <div>
            <label>Views</label>
            <span>{video.stats.totalViews}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
